import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { I18nProvider } from "./i18n/I18nContext";
import { ProtectedRoute } from "./components/nivara/ProtectedRoute";
import { TopBar } from "./components/nivara/TopBar";
import { Toaster } from "sonner";

import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import DashboardRedirect from "./pages/DashboardRedirect";
import ParticipantDashboard from "./pages/ParticipantDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import ControllerDashboard from "./pages/ControllerDashboard";
import AdminGroupsPage from "./pages/AdminGroupsPage";
import CreateGroupPage from "./pages/CreateGroupPage";
import GroupDetailPage from "./pages/GroupDetailPage";
import AdminUsersPage from "./pages/AdminUsersPage";
import AdminLeadsPage from "./pages/AdminLeadsPage";
import PaymentsPage from "./pages/PaymentsPage";
import AuctionsListPage from "./pages/AuctionsListPage";
import AuctionPage from "./pages/AuctionPage";
import NotificationsPage from "./pages/NotificationsPage";
import AuditLogPage from "./pages/AuditLogPage";
import ParticipantGroupRedirect from "./pages/ParticipantGroupRedirect";

function Layout({ children }) {
  return (
    <>
      <TopBar />
      {children}
    </>
  );
}

function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          {/* Public */}
          <Route path="/" element={<><TopBar /><LandingPage /></>} />
          <Route path="/login" element={<LoginPage />} />
          {/* Self-registration removed — interest form on landing page replaces it */}
          <Route path="/register" element={<Navigate to="/#interest" replace />} />

          {/* Auth */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Layout><DashboardRedirect /></Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/participant"
            element={
              <ProtectedRoute roles={["participant", "admin", "controller"]}>
                <Layout><ParticipantDashboard /></Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/admin"
            element={
              <ProtectedRoute roles={["admin"]}>
                <Layout><AdminDashboard /></Layout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/controlling"
            element={
              <ProtectedRoute roles={["controller", "admin"]}>
                <Layout><ControllerDashboard /></Layout>
              </ProtectedRoute>
            }
          />

          {/* Admin groups */}
          <Route
            path="/admin/groups"
            element={<ProtectedRoute roles={["admin", "controller"]}><Layout><AdminGroupsPage /></Layout></ProtectedRoute>}
          />
          <Route
            path="/admin/groups/new"
            element={<ProtectedRoute roles={["admin"]}><Layout><CreateGroupPage /></Layout></ProtectedRoute>}
          />
          <Route
            path="/admin/groups/:id"
            element={<ProtectedRoute><Layout><GroupDetailPage /></Layout></ProtectedRoute>}
          />
          <Route
            path="/admin/users"
            element={<ProtectedRoute roles={["admin"]}><Layout><AdminUsersPage /></Layout></ProtectedRoute>}
          />
          <Route
            path="/admin/leads"
            element={<ProtectedRoute roles={["admin", "controller"]}><Layout><AdminLeadsPage /></Layout></ProtectedRoute>}
          />
          <Route
            path="/admin/payments"
            element={<ProtectedRoute roles={["admin", "controller"]}><Layout><PaymentsPage /></Layout></ProtectedRoute>}
          />
          <Route
            path="/admin/auctions"
            element={<ProtectedRoute roles={["admin", "controller"]}><Layout><AuctionsListPage /></Layout></ProtectedRoute>}
          />

          {/* Controller */}
          <Route
            path="/controlling/payments"
            element={<ProtectedRoute roles={["controller", "admin"]}><Layout><PaymentsPage /></Layout></ProtectedRoute>}
          />
          <Route
            path="/controlling/auctions"
            element={<ProtectedRoute roles={["controller", "admin"]}><Layout><AuctionsListPage /></Layout></ProtectedRoute>}
          />
          <Route
            path="/controlling/exports"
            element={<ProtectedRoute roles={["controller", "admin"]}><Layout><ControllerDashboard /></Layout></ProtectedRoute>}
          />

          {/* Participant-specific */}
          <Route
            path="/my/group"
            element={<ProtectedRoute><Layout><ParticipantGroupRedirect /></Layout></ProtectedRoute>}
          />
          <Route
            path="/my/payments"
            element={<ProtectedRoute><Layout><PaymentsPage /></Layout></ProtectedRoute>}
          />
          <Route
            path="/my/auctions"
            element={<ProtectedRoute><Layout><AuctionsListPage /></Layout></ProtectedRoute>}
          />

          {/* Shared */}
          <Route
            path="/auctions/:id"
            element={<ProtectedRoute><Layout><AuctionPage /></Layout></ProtectedRoute>}
          />
          <Route
            path="/notifications"
            element={<ProtectedRoute><Layout><NotificationsPage /></Layout></ProtectedRoute>}
          />
          <Route
            path="/audit-log"
            element={<ProtectedRoute roles={["admin", "controller"]}><Layout><AuditLogPage /></Layout></ProtectedRoute>}
          />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
    </I18nProvider>
  );
}

export default App;
